import { createRoute } from '@tanstack/react-router'
import { Gauge, Building, CalendarCheck2, CalendarClock, CalendarDays, DoorOpen, Droplets, Gavel, Landmark, Megaphone, MessagesSquare, Monitor, Scale, Wrench } from 'lucide-react'
import type { NavItem } from '../components/Shell.tsx'
import { Agenda } from './agenda.tsx'
import { ChatModeration, Conversations, ThreadPage } from './chat.tsx'
import { Assemblies, AssemblyPage } from './assemblies.tsx'
import { Displays, Notices } from './community.tsx'
import { Building as BuildingPage, Obligations, Reservations, TicketPage, Tickets } from './facilities.tsx'
import { TvPage } from './tv.tsx'
import { Finance } from './finance.tsx'
import { Portaria } from './portaria.tsx'
import { Consumo } from './consumo.tsx'
import { Penalties } from './penalties.tsx'
import { Privacy, Terms } from './legal.tsx'
import { Assistants } from './assistants.tsx'
import { OAuthConsent } from './oauth.tsx'
import { VerifyPage } from './verify.tsx'
import { Painel } from './painel.tsx'
import { t } from '../lib/i18n.ts'

// Modules from later phases register their navigation and routes here.
export const extraNav: NavItem[] = [
  { to: '/painel', label: t('Painel'), icon: Gauge, cap: 'finance.view' },
  { to: '/avisos', label: t('Avisos'), icon: Megaphone },
  { to: '/conversas', label: t('Conversas'), icon: MessagesSquare },
  { to: '/agenda', label: t('Agenda'), icon: CalendarDays },
  { to: '/assembleias', label: t('Assembleias'), icon: Gavel },
  { to: '/reservas', label: t('Reservas'), icon: CalendarCheck2 },
  { to: '/portaria', label: t('Portaria'), icon: DoorOpen },
  { to: '/consumo', label: t('Consumo'), icon: Droplets },
  { to: '/chamados', label: t('Chamados'), icon: Wrench },
  { to: '/advertencias', label: t('Advertências'), icon: Scale },
  { to: '/prazos', label: t('Prazos'), icon: CalendarClock },
  { to: '/predio', label: t('Prédio'), icon: Building },
  { to: '/financas', label: t('Finanças'), icon: Landmark },
  { to: '/telas', label: t('Telas (TV)'), icon: Monitor, cap: 'displays.manage' },
]

export const extraCondoRoutes = (parent: any): any[] => [
  createRoute({ getParentRoute: () => parent, path: '/assembleias', component: Assemblies }),
  createRoute({ getParentRoute: () => parent, path: '/assembleias/$aid', component: AssemblyPage }),
  createRoute({ getParentRoute: () => parent, path: '/painel', component: Painel }),
  createRoute({ getParentRoute: () => parent, path: '/avisos', component: Notices }),
  createRoute({ getParentRoute: () => parent, path: '/conversas', component: Conversations }),
  createRoute({ getParentRoute: () => parent, path: '/conversas/denuncias', component: ChatModeration }),
  createRoute({ getParentRoute: () => parent, path: '/conversas/$tid', component: ThreadPage }),
  createRoute({ getParentRoute: () => parent, path: '/agenda', component: Agenda }),
  createRoute({ getParentRoute: () => parent, path: '/telas', component: Displays }),
  createRoute({ getParentRoute: () => parent, path: '/reservas', component: Reservations }),
  createRoute({ getParentRoute: () => parent, path: '/portaria', component: Portaria }),
  createRoute({ getParentRoute: () => parent, path: '/consumo', component: Consumo }),
  createRoute({ getParentRoute: () => parent, path: '/chamados', component: Tickets }),
  createRoute({ getParentRoute: () => parent, path: '/chamados/$tid', component: TicketPage }),
  createRoute({ getParentRoute: () => parent, path: '/advertencias', component: Penalties }),
  createRoute({ getParentRoute: () => parent, path: '/prazos', component: Obligations }),
  createRoute({ getParentRoute: () => parent, path: '/predio', component: BuildingPage }),
  createRoute({ getParentRoute: () => parent, path: '/financas', component: Finance }),
]
export const extraRootRoutes = (root: any): any[] => [
  createRoute({ getParentRoute: () => root, path: '/verificar/$code', component: VerifyPage }),
  createRoute({ getParentRoute: () => root, path: '/tv/$token', component: TvPage }),
  createRoute({ getParentRoute: () => root, path: '/oauth/consent', component: OAuthConsent }),
  createRoute({ getParentRoute: () => root, path: '/privacidade', component: Privacy }),
  createRoute({ getParentRoute: () => root, path: '/termos', component: Terms }),
  createRoute({ getParentRoute: () => root, path: '/assistentes', component: Assistants }),
]
